import React from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase";

import LoginForm from "./components/login-form";
import AdminForm from "./components/admin-form";

const AdminPage: React.FC = () => {
  const [user] = useAuthState(auth);

  console.log({ user });

  if (!user) {
    return <LoginForm />;
  }

  return (
    <div className="container mx-auto">
      <h2 className="text-2xl font-bold mb-4">Admin Page</h2>
      <p className="mb-4">Welcome, {user.email}</p>
      <button
        onClick={() => auth.signOut()}
        className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 mb-4"
      >
        Logout
      </button>
      <AdminForm />
    </div>
  );
};

export default AdminPage;
